import type { AxiosRequestConfig } from 'axios'
import ApiClient from './apiClient'
import {
  normalizeAllowedActions,
  normalizeAppMenuFeatures,
  normalizePermissionEnvelope,
  normalizePermissionMap,
} from '../permissions/normalize'

export const normalizePermissionEndpoint = (endpoint: string): string =>
  endpoint
    .replace(/^\/?backend\/api\//, '')
    .replace(/^\/?api\//, '')
    .replace(/^\/+/, '')

const permissionService = {
  getDedicatedPermissions: async (endpoint: string, config?: AxiosRequestConfig) => {
    const response = await ApiClient.get(normalizePermissionEndpoint(endpoint), config)

    return normalizePermissionEnvelope(response.data)
  },
  normalizeAppMenuFeatures,
  normalizePermissionMap,
  normalizeAllowedActions,
  normalizePermissionEnvelope,
}

export default permissionService
